import type { PointData, ObservablePoint } from 'pixi.js';

export default function applyAnchor<T extends { anchor: ObservablePoint }>(
  object: T,
  anchor: number | PointData | undefined,
): void {
  if (anchor === undefined) return;
  if (object.anchor)
    if (typeof anchor === 'number') {
      object.anchor.set(anchor, anchor);
    } else {
      const { x, y } = anchor;
      object.anchor.set(x, y);
    }
}
